import './style.css';

const ProjectVisual = ({ data, projectId, useContainedMedia = false }) => {
  const imageSource = data?.full || data?.preview;
  if (!imageSource) return null;

  return (
    <section
      className="project-visual"
      data-project-id={projectId}
      data-project-template={useContainedMedia ? 'project-01' : undefined}
      aria-label={data.ariaLabel || 'Ключевой визуал проекта'}
    >
      <figure className="project-visual__frame">
        <img
          src={imageSource}
          alt={data.alt}
          className={`project-visual__image${useContainedMedia ? ' project-visual__image--contain' : ''}`}
          loading="lazy"
        />
      </figure>
    </section>
  );
};

export default ProjectVisual;
